import { createFileHash } from "#modules/parts/domain/createFileHash";
import { getFileBaseName, groupFilesByBaseName, stripExistingHashPrefix } from "shared";

import { CreatePartRequestBody } from "../infra/createPart.api";

interface PartData extends Omit<CreatePartRequestBody, "files"> {
  files: { data: File; name: string; hash: string; size: number }[];
}

export const getPartsFromFiles = async (files: File[]): Promise<PartData[]> => {
  const filesData = await Promise.all(
    files.map(async (file) => {
      const name = getFileBaseName(stripExistingHashPrefix(file.name));
      const hash = await createFileHash(file);

      return { name, file, hash, size: file.size };
    }),
  );

  return groupFilesByBaseName(filesData).map((group) => ({
    name: group[0]!.name,
    files: group.map((fileData) => ({
      name: fileData.name,
      data: fileData.file,
      hash: fileData.hash,
      size: fileData.size,
    })),
  }));
};
